import { SelectOption } from "../../../../types/select";
import { isSelectOption } from "./isSelectOption";

export function extractValue<T = unknown>(value: SelectOption<T> | T | null | undefined): T | null {
  if (value == null) return null;
  if (isSelectOption(value)) return (value.value as T) ?? null;

  return value as T;
}
